import React from 'react';

const ReturnsPolicyPage = () => {
  return (
    <div className="min-h-screen bg-[#F5F5DC] pt-40 pb-20 px-6 max-w-3xl mx-auto text-left font-sans text-[#2C1E12]">
      <h2 className="text-3xl font-serif uppercase tracking-wider mb-2">Returns & Exchanges Policy</h2>
      <p className="text-[10px] uppercase tracking-[0.2em] text-zinc-500 mb-8 border-b border-[#2C1E12]/10 pb-4">3-Day Premium Protection Framework Clauses</p>
      
      <div className="space-y-6 text-xs leading-relaxed font-serif text-zinc-700">
        <div>
          <h4 className="text-sm font-sans font-black uppercase tracking-wider text-[#2C1E12] mb-2">1. 3-Day Framework Limitation</h4>
          <p>Modische Kledings enforces a strict, premium **3-day policy file limit**. Return requests or pattern size exchange requests must be filed directly within **3 days (72 hours)** of your delivery timestamp logs through your account profile order history panel.</p>
        </div>
        <div>
          <h4 className="text-sm font-sans font-black uppercase tracking-wider text-[#2C1E12] mb-2">2. No Questions Asked Eligibility</h4>
          <p>We accept returns/exchanges for any style preference choice, size mismatch, item quality preference variation, or change of mind scenario. The product must remain unwashed, completely unworn, with all original protective luxury layers and designer product tags intact.</p>
        </div>
        <div>
          <h4 className="text-sm font-sans font-black uppercase tracking-wider text-[#2C1E12] mb-2 text-red-950">3. Unboxing Video Verification Requirement</h4>
          <p className="font-bold text-zinc-800">For assertions involving damaged items, incorrect product sizes sent by company error, or missing quantities inside your shipping package, customers are strictly required to provide a continuous, unedited unboxing opening video. Up to 6 verification photo assets must be attached inside the user portal request desk.</p>
        </div>
        <div>
          <h4 className="text-sm font-sans font-black uppercase tracking-wider text-[#2C1E12] mb-2">4. Settlement Turnaround</h4>
          <p>Approved return claims are settled via store platform ledger credit values or sent back into your original automated online bank payment option channel within 7 to 10 working financial business days. Original shipping dispatch fees are non-refundable.</p>
        </div>
      </div>
    </div>
  );
};

export default ReturnsPolicyPage;